import SsgFallback from '@components/SsgFallback'
import getStoresAvailableForReservation from '@data/queries/reservations/getStoresAvailableForReservation.reservations'
import getWebsiteInitialData from '@data/queries/website/websiteInitialData.main'
import getWebsitePagesInfo from '@data/queries/website/websitePagesInfo'
import websiteSSRTranslations from '@helpers/misc/websiteSSRTranslations'
import getSsrComponentMap from '@helpers/ssr/getSsrComponentMap'
import getWebsiteIdFromHostname from '@helpers/websites/getWebsiteIdFromHostname'
import DeactivatedByDebt from '@page-components/DeactivatedByDebt'
import AbstractLayout from '@page-components/Layout/AbstractLayout'
import Website from '@page-components/Layout/Website'
import NoWebsite from '@page-components/NoWebsite'
import Page from '@page-components/Page'
import ReservationsSelectStore from '@page-components/Reservations/SelectStore'
import {InferGetStaticPropsType} from 'next'
import {useRouter} from 'next/router'

export default function ReservasIndex(props: InferGetStaticPropsType<typeof getStaticProps>) {
  const router = useRouter()
  if (router.isFallback) {
    return <SsgFallback />
  }

  if (!props.website) {
    return <NoWebsite />
  }

  if (props.website.isDeactivatedByDebt) {
    return <DeactivatedByDebt />
  }

  return (
    <AbstractLayout LayoutComponent={Website} initialData={props.initialData}>
      {props.page && (
        <Page
          pageId={props.page._id}
          page={props.page}
          componentIdToSsrProps={props.componentIdToSsrProps}
        />
      )}
      {props.storesOptions.length !== 0 && (
        <ReservationsSelectStore storesOptions={props.storesOptions} />
      )}
    </AbstractLayout>
  )
}

export const getStaticProps = async context => {
  const {websiteId} = await getWebsiteIdFromHostname(context.params.hostname)
  const initialData = await getWebsiteInitialData(websiteId)
  const {website} = await getWebsitePagesInfo(websiteId)
  const storesOptions = await getStoresAvailableForReservation(websiteId)
  const translationProps = await websiteSSRTranslations(website, [
    'website',
    'generic',
    'deprecated'
  ])

  const {componentIdToSsrProps, page} = await getSsrComponentMap(
    website,
    initialData,
    context.params.viewport,
    '/reservas'
  )

  const props = {
    ...translationProps,
    initialData,
    websiteId,
    website,
    storesOptions,
    componentIdToSsrProps,
    page,
    lastRevalidatedAt: new Date().toISOString()
  }

  if (storesOptions.length === 1 && storesOptions[0] && !page) {
    return {
      props,
      redirect: {
        destination: `/reservas/${storesOptions[0]._id}`
      }
    }
  }

  return {
    props,
    revalidate: 60 * 60 * 1
  }
}

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: true
  }
}
